
import { Pipe, PipeTransform } from '@angular/core';
import { take, takeRight } from 'lodash-es';

/**
 * Truncates the middle of a text
 */
@Pipe({
  name: 'truncateMiddle'
})
export class TruncateMiddlePipe implements PipeTransform {

  transform(value: string, maxLength: number): string {
    const elipses = '...';
    if (value && value.length < maxLength) {
      return value;
    }

    const first = Math.floor(maxLength / 2) - 1;
    const last = Math.ceil(maxLength / 2) - 2;
    const start = take(value, first).join('');
    const end = takeRight(value, last).join('');

    return `${start}${elipses}${end}`;
  }
}


